import React, { useState } from 'react';
import { Group, Rect } from 'react-konva';
import { EventContext } from './useEventTarget';
import useLocalTransform from './utils/useLocalTransform';

/**
 * A Group component that draws a transparent Rect behind it's children allowing
 * it to accept mouse events across the entire Group, not just for "visible" shapes
 * inside the Group.
 */
function DrawingOverlay({
  children
}) {
  const [ref, setRef] = useState(null);
  const {
    width,
    height
  } = useLocalTransform();
  return React.createElement(Group, {
    ref: setRef
  }, React.createElement(Rect, {
    width: width,
    height: height,
    opacity: 0
  }), React.createElement(EventContext.Provider, {
    value: ref
  }, children));
}

export default DrawingOverlay;